var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-form" },
    [
      _vm.step == 1
        ? _c("login-step1", {
            attrs: { lang: _vm.lang, login_social: _vm.login_social },
            on: {
              next: function($event) {
                return _vm.nextStep($event)
              },
              loginSuccess: function($event) {
                return _vm.onLoginSuccess($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.step == 2
        ? _c("login-step2", {
            attrs: { lang: _vm.lang },
            on: {
              next: function($event) {
                return _vm.loginStep($event)
              },
              loginSuccess: function($event) {
                return _vm.onLoginSuccess($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.step == 3
        ? _c("login-step3", {
            attrs: { lang: _vm.lang },
            on: {
              registerSuccess: function($event) {
                return _vm.onRegisterSuccess($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }